export var EFrequency;

(function (EFrequency) {
  EFrequency["Asap"] = "asap";
  EFrequency["Daily"] = "daily";
  EFrequency["Hourly"] = "hourly";
  EFrequency["Weekly"] = "weekly";
})(EFrequency || (EFrequency = {}));